import { GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS, GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS, GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS, GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES, GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD, GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS, GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_SUCCESS, GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS, GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR, GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS, GET_QUOTE_FUNNELS_SOURCE_STATS, GET_QUOTE_FUNNELS_SOURCE_STATS_ERROR, GET_QUOTE_FUNNELS_SOURCE_STATS_SUCCESS  } from "./actionTypes"

export const getQuoteFunnelsStatsForDashboard = (dashboard_query_params, api_type) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD,
    payload: dashboard_query_params,
    api_type: api_type
  }
}

export const getQuoteFunnelsStatsForDashboardSuccess = (quote_funnels_stats, api_type) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_SUCCESS,
    payload: quote_funnels_stats,
    api_type: api_type
  }
}

export const getQuoteFunnelsStatsForDashboardError = (error, api_type) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_ERROR,
    payload: error,
    api_type: api_type
  }
}

export const getQuoteFunnelsStatsForAnalytics = (analytics_params) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS,
    payload: analytics_params
  }
}

export const getQuoteFunnelsStatsForAnalyticsSuccess = (quote_funnels_stats) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_SUCCESS,
    payload: quote_funnels_stats
  }
}

export const getQuoteFunnelsStatsForAnalyticsError = (error) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_ERROR,
    payload: error
  }
}

export const getQuoteFunnelsStatsForCampaigns = (campaigns_params) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS,
    payload: campaigns_params
  }
}

export const getQuoteFunnelsStatsForCampaignsSuccess = (quote_funnels_stats) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS,
    payload: quote_funnels_stats
  }
}

export const getQuoteFunnelsStatsForCampaignsError = (error) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR,
    payload: error
  }
}

// camapign aggregated data for goal/quote_funnels
export const getAggQuoteFunnelsStatsForCampaigns = (campaigns_params) => { 
  return {
    type: GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS,
    payload: campaigns_params
  }
}

export const getAggQuoteFunnelsStatsForCampaignsSuccess = (quote_funnels_stats) => {
  return {
    type: GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS,
    payload: quote_funnels_stats
  }
}

export const getAggQuoteFunnelsStatsForCampaignsError = (error) => { 
  return {
    type: GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR,
    payload: error
  }
}

export const getQuoteFunnelsStatsForAdGroups = (adgroups_params) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS,
    payload: adgroups_params
  }
}

export const getQuoteFunnelsStatsForAdGroupsSuccess = (quote_funnels_stats) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_SUCCESS,
    payload: quote_funnels_stats
  }
}

export const getQuoteFunnelsStatsForAdGroupsError = (error) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_ERROR,
    payload: error
  }
}

export const getQuoteFunnelsStatsForSourceSettings = (source_settings_params) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS,
    payload: source_settings_params
  }
}

export const getQuoteFunnelsStatsForSourceSettingsSuccess = (quote_funnels_stats) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_SUCCESS,
    payload: quote_funnels_stats
  }
}

export const getQuoteFunnelsStatsForSourceSettingsError = (error) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_ERROR,
    payload: error
  }
}

export const getQuoteFunnelsStatsForCreatives = (creatives_params) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES,
    payload: creatives_params
  }
}

export const getQuoteFunnelsStatsForCreativesSuccess = (quote_funnels_stats) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_SUCCESS,
    payload: quote_funnels_stats
  }
}

export const getQuoteFunnelsStatsForCreativesError = (error) => {
  return {
    type: GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_ERROR,
    payload: error
  }
}

export const getQuoteFunnelsSourceStats = (source_stats_params) => {
  return {
    type: GET_QUOTE_FUNNELS_SOURCE_STATS,
    payload: source_stats_params
  }
}

export const getQuoteFunnelsSourceStatsSuccess = (source_stats) => {
  return {
    type: GET_QUOTE_FUNNELS_SOURCE_STATS_SUCCESS,
    payload: source_stats
  }
}

export const getQuoteFunnelsSourceStatsError = (error) => {
  return {
    type: GET_QUOTE_FUNNELS_SOURCE_STATS_ERROR,
    payload: error
  }
}